import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const forWho = ['Profesionales con altos niveles de estrés que no pueden dejar de pensar en el trabajo.', 'Personas que se despiertan sistemáticamente entre la 1:00 AM y las 3:00 AM.', 'Quienes sufren de "mente acelerada" y ansiedad nocturna.', 'Personas que quieren dejar de depender de fármacos para descansar.'];
const notForWho = ['Personas que buscan una pastilla mágica y no están dispuestas a usar sus manos por 10 minutos.', 'Gente que no cree en la medicina natural o la bioenergética.', 'Casos médicos de apnea obstructiva del sueño que requieren maquinaria clínica.'];
export function WhoIsFor() {
  return <section className="w-full bg-navy-900 px-4 py-20" data-id="element-161">
      <div className="max-w-5xl mx-auto" data-id="element-162">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-163">
          <h2 className="font-serif text-3xl md:text-4xl text-white mb-4" data-id="element-164">
            ¿Es Esto Para Ti?
          </h2>
          <div className="h-1 w-24 bg-gold mx-auto" data-id="element-165"></div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-166">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-navy-800/50 border border-green-500/30 rounded-lg p-8" data-id="element-167">
            <h3 className="font-serif text-2xl text-white mb-6 flex items-center gap-3" data-id="element-168">
              <CheckIcon className="w-6 h-6 text-green-500" data-id="element-169" />
              Esto es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-170">
              {forWho.map((item, index) => <li key={index} className="flex gap-3 text-gray-300" data-id="element-171">
                  <CheckIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-1" data-id="element-172" />
                  <span data-id="element-173">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-navy-800/50 border border-red-500/30 rounded-lg p-8" data-id="element-174">
            <h3 className="font-serif text-2xl text-white mb-6 flex items-center gap-3" data-id="element-175">
              <XIcon className="w-6 h-6 text-red-500" data-id="element-176" />
              Esto NO es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-177">
              {notForWho.map((item, index) => <li key={index} className="flex gap-3 text-gray-300" data-id="element-178">
                  <XIcon className="w-5 h-5 text-red-500 flex-shrink-0 mt-1" data-id="element-179" />
                  <span data-id="element-180">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}